import { Pill } from 'components/ManagementCard'
import { banStatusStrings, organizationManagementStrings } from 'constants/strings'
import type { TBanStatusOrganization } from 'types'
import { formatNumber } from 'utils'

type BlockedOrganizationsProps = {
  organizations: TBanStatusOrganization[]
}

/**
 * 払い出し可能なチャンネルが1件も無い組織。
 * 友だち追加もBAN時の別アカウント誘導も止まるため、最も重い状態として最上部に出す。
 */
export function BlockedOrganizations({
  organizations,
}: BlockedOrganizationsProps) {
  if (organizations.length === 0) {
    return (
      <p className="mt-6 rounded-2xl border border-border/70 bg-white p-4 text-sm text-muted">
        {banStatusStrings.alert.none}
      </p>
    )
  }

  return (
    <section
      data-testid="blocked-organizations"
      className="mt-6 rounded-2xl border border-danger-border bg-danger-soft p-4"
    >
      <h2 className="text-sm font-semibold text-danger">
        {banStatusStrings.alert.heading}
      </h2>
      <p className="mt-1 text-xs text-danger">
        {banStatusStrings.alert.description}
      </p>
      <ul className="mt-3 grid gap-2 sm:grid-cols-2 lg:grid-cols-3">
        {organizations.map((organization) => (
          <li
            key={organization.organizationId}
            className="flex items-center gap-2 rounded-xl border border-danger-border bg-white px-3 py-2"
          >
            <span className="truncate text-sm font-semibold text-ink">
              {organization.organizationName}
            </span>
            <Pill tone="neutral" className="ml-auto">
              {organizationManagementStrings.planLabels[organization.plan]}
            </Pill>
            <span className="shrink-0 text-[11px] tabular-nums text-danger">
              {formatNumber(organization.total)}
              {banStatusStrings.alert.channelSuffix}
            </span>
          </li>
        ))}
      </ul>
    </section>
  )
}
